
export const baseUrl = "https://chatmd.fly.dev";
